import styled from 'styled-components'

export const HeaderContainer = styled.div`
    padding: 9px;
    background-color: black;
`

export const HeaderText = styled.p`
    margin: 0;
    display: inline;    
`
